import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React, { useCallback } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { MetisApp } from '@yuanfudao/metis-web-component';
import icWarning from '../asset/common/warn.png';
import lessModule from '../styles/reset/antd-confirm.module.less';
// eslint-disable-next-line arrow-body-style
export var useConfirmWarning = function useConfirmWarning() {
  var _MetisApp$useApp = MetisApp.useApp(),
    antModal = _MetisApp$useApp.modal;
  var fn = useCallback(function (config) {
    return antModal.confirm(_objectSpread(_objectSpread({
      okButtonProps: {
        loading: false
      },
      okText: '确 定',
      cancelText: '取 消'
    }, config), {}, {
      title: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
        className: "rewrite-confirm-icon",
        src: icWarning,
        alt: ""
      }), config.title),
      className: lessModule.rewriteConfirm,
      // icon: <img className="rewrite-confirm-icon" src={icWarning} alt="" />,
      icon: null,
      centered: true,
      closable: false,
      style: {
        background: 'linear-gradient(0deg, #FFFFFF, #FFFFFF)',
        boxShadow: '0px 12px 32px rgba(24, 33, 41, 0.16)',
        borderRadius: '8px',
        paddingBottom: 0
      }
    }));
  }, [antModal]);
  return fn;
};
// eslint-disable-next-line arrow-body-style
// export const ConfirmWarning = (config: Partial<ModalFuncProps>) => {
//   return Modal.confirm({
//     okButtonProps: {
//       loading: false,
//     },
//     ...config,
//     className: lessModule.rewriteConfirm,
//     icon: <img className="rewrite-confirm-icon" src={icWarning} alt="" />,
//     centered: true,
//     style: {
//       background: 'linear-gradient(0deg, #FFFFFF, #FFFFFF)',
//       boxShadow: '0px 12px 32px rgba(24, 33, 41, 0.16)',
//       borderRadius: '8px',
//       paddingBottom: 0,
//     },
//   })
// }